import { render, staticRenderFns } from "./YesNoDialog.vue?vue&type=template&id=4860f4de&scoped=true"
import script from "./YesNoDialog.vue?vue&type=script&lang=ts"
export * from "./YesNoDialog.vue?vue&type=script&lang=ts"
import style0 from "./YesNoDialog.vue?vue&type=style&index=0&id=4860f4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860f4de",
  null
  
)

export default component.exports